// 채널톡 SDK 위젯 연동
// SDK 로더는 public/index.html 에 있음. 여기서는 boot/open/shutdown 만 다룸.

const PLUGIN_KEYS = {
  realtor: '7f8198f9-8ee9-4acc-b9e7-02a9b24de0ec',
  partner: '2d5f3d24-a14e-4471-85c4-b6d8fa728234',
};

// 역할별 채널톡 워크플로우 URL — SDK 의 showMessenger 는 기본 챗 (고객 흐름) 만 띄우므로
// 부동산/제휴는 명시적인 workflow URL 로 보내야 해당 챗 봇이 실행됨
const WORKFLOW_URLS = {
  partner: 'https://ieum.channel.io/workflows/822094',
  realtor: 'https://ieum.channel.io/workflows/822093',
};

export const openChannelTalkWorkflow = (role) => {
  const url = WORKFLOW_URLS[role];
  if (!url) return;
  if (typeof window === 'undefined') return;
  // 인앱 모달 (iframe) — App.js 에 마운트된 ChannelTalkModal 이 받아서 띄움
  window.dispatchEvent(new CustomEvent('ieum:open-channel-talk', { detail: { url } }));
};

const callCh = (...args) => {
  if (typeof window === 'undefined' || !window.ChannelIO) return;
  window.ChannelIO(...args);
};

// 메신저 열림/닫힘 상태 — 하드웨어 뒤로가기 처리용
let messengerOpen = false;
const openListeners = new Set();
const emit = () => openListeners.forEach((cb) => { try { cb(messengerOpen); } catch {} });

export const isMessengerOpen = () => messengerOpen;
export const subscribeMessengerState = (cb) => {
  openListeners.add(cb);
  return () => openListeners.delete(cb);
};

export const bootChannelTalk = (role, profile = {}) => {
  const pluginKey = PLUGIN_KEYS[role];
  if (!pluginKey) return;
  callCh('boot', {
    pluginKey,
    memberId: profile.uid,
    profile: {
      name: profile.name,
      mobileNumber: profile.phone,
      email: profile.email,
    },
  });
  callCh('hideChannelButton');
  callCh('onShowMessenger', () => { messengerOpen = true; emit(); });
  callCh('onHideMessenger', () => { messengerOpen = false; emit(); });
};

export const openChannelTalk = () => {
  callCh('showMessenger');
};

export const closeChannelTalk = () => {
  callCh('hideMessenger');
};

export const shutdownChannelTalk = () => {
  callCh('shutdown');
  messengerOpen = false;
  emit();
};
